/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rating-container[_ngcontent-%COMP%]{color:#f5a623;display:flex;align-items:center}.rating-container[_ngcontent-%COMP%]   .exact[_ngcontent-%COMP%]{color:#5f6062}"];
export { styles as styles };
